import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class ModalPaymentHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentDetail: null,
            typeSelect: null
        }
    }
    componentWillReceiveProps(nextProps) {
        const icoinPlusId = nextProps.icoinPlusId;
        const typeSelected = nextProps.typeSelected;

        const json = {
            id: Number(icoinPlusId),
            type: typeSelected
        }

        if (icoinPlusId) {
            if (typeSelected == "FISHHUNTER") {
                axios.post(global.config.apiDomain + '/payment/web/payment-details', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            } else {
                axios.post(global.config.apiDomain + '/rest/admin/getPaymentDetail', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({
                        paymentDetail: res.data,
                        typeSelect: typeSelected
                    })
                }, err => {
                    toast.error(err);
                });
            }
        }
    }


    getTitleTargetUser(type) {
        switch (type) {
            case 'TRANSFERTO':
                return "Sender"
            case 'TRANSFERFROM':
                return "Receiver"
            default:
                return "Receiver"
        }
    }

    render() {
        const { paymentDetail, typeSelect } = this.state;

        return (
            <div>
                <div className="modal fade" id="modalPaymentHistory" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Lịch sử chi tiết</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {typeSelect === "FISHHUNTER" && paymentDetail && (
                                    <>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Thời gian</th>
                                                    <th>Icoin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentDetail.details.map((detail, index) => (
                                                    <tr key={index}>
                                                        <td>{new Date(detail.logTime).toLocaleString('vi-VN')}</td>
                                                        <td>{detail.icoin > 0 ? `+${detail.icoin}` : detail.icoin}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                                {paymentDetail && typeSelect !== "FISHHUNTER" && (
                                    <div>
                                        <h3>{typeSelect && typeSelect === "RENEWLIVEROOM" ? "Payer" : "Owner"}</h3>
                                        <ol>
                                            <li>FacebookID: {paymentDetail.user.facebookId}</li>
                                            <li>DeviceID: {paymentDetail.deviceId}</li>
                                            <li>UID: {paymentDetail.user.uid}</li>
                                            <li>Name: {paymentDetail.user.name}</li>
                                            <li>Avatar: <img src={paymentDetail.user.profileImageLink} height={50} width={50} alt="avatar" /></li>
                                        </ol>
                                        {paymentDetail.targetUser && (
                                            <>
                                                <h3>{this.getTitleTargetUser(paymentDetail.type)}</h3>
                                                <ol>
                                                    <li>FacebookID: {paymentDetail.targetUser.facebookId}</li>
                                                    <li>UID: {paymentDetail.targetUser.uid}</li>
                                                    <li>Name: {paymentDetail.targetUser.name}</li>
                                                    <li>Avatar: <img src={paymentDetail.targetUser.profileImageLink} height={50} width={50} alt="avatar" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.gift && (
                                            <>
                                                <h3>Gift</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.gift.id}</li>
                                                    <li>Name: {paymentDetail.gift.name}</li>
                                                    <li>BuyPrice: {paymentDetail.gift.buyPrice}</li>
                                                    <li>SellPrice: {paymentDetail.gift.sellPrice}</li>
                                                    <li>NoItem: {paymentDetail.gift.noItem}</li>
                                                    <li>Img: <img src={paymentDetail.gift.url} height={50} width={50} alt="gift" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.luckyGift && (
                                            <>
                                                <h3>LuckyGift</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.luckyGift.id}</li>
                                                    <li>Name: {paymentDetail.luckyGift.name}</li>
                                                    <li>BuyPrice: {paymentDetail.luckyGift.buyPrice}</li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.recording && (
                                            <>
                                                <h3>Recording</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.recording._id}</li>
                                                    <li>Name: {paymentDetail.recording.yourName}</li>
                                                    <li>URL: <a href={paymentDetail.recording.onlineRecordingUrl}>{paymentDetail.recording.yourName}</a></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.liveRoom && (
                                            <>
                                                <h3>LiveRoom</h3>
                                                <ol>
                                                    <li>ID: {paymentDetail.liveRoom.id}</li>
                                                    <li>UID: {paymentDetail.liveRoom.uid}</li>
                                                    <li>Name: {paymentDetail.liveRoom.name}</li>
                                                    <li>Img: <img src={paymentDetail.liveRoom.thumbnail} height={50} width={50} alt="room" /></li>
                                                </ol>
                                            </>
                                        )}
                                        {paymentDetail.reason && (
                                            <>
                                                <h3>Lí do</h3>
                                                <p>{paymentDetail.reason}</p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}